window.dn = window.dn || {};

(function (agreement, $, undefined)
{
    agreement.ShowId = 'dn-modal-agreement';

    /**
     * Check and see if the user is up-to-date on the given agreement, and if not, show our agreement modal.
     * 
     * If the user is up-to-date on the given agreement, or the given agreement is kn
     * 
     * @param {string} agreementType    - The user agreement that they need to agree to. Currently, only "Bounties" is supported.
     * @param {func} onAgreed           - Callback that will be run when the agreement is completed.
     * @param {func} onClose            - Callback that will be run if the modal is closed before agreeing.
     */
    agreement.Verify = function(agreementType, onAgree, onClose)
    {
        if (agreementType === 'Bounties')
        {
            if (!dn.user.DateAgreedBounties)
            {
                agreement.Show(agreementType, onAgree, onClose);
            }
            else if (onAgree)
            {
                onAgree();
            }
        }
        else
        {
            console.error('Unrecognized agreement type: ' + agreementType);
        }
    };

    /**
     * Show the agreement modal popup.
     * 
     * @param {string} agreementType    - The user agreement that they need to agree to. Currently, only "Bounties" is supported.
     * @param {func} onAgreed           - Callback that will be run when the agreement is completed.
     * @param {func} onClose            - Callback that will be run if the modal is closed before agreeing.
     */
    agreement.Show = function(agreementType, onAgree, onClose, hideButtons) {

        var title = "Bounties & Tokens User Agreement";
        var footerVisibility = hideButtons ? 'd-none' : '';

        $('#' + agreement.ShowId).remove();  // remove if it already exists
        $("body").append($('<div class="modal dn-modal-agreement" tabindex="-1" role="dialog" style="display: none" id="' + agreement.ShowId + '">\
            <div class="modal-dialog" role="document">\
                <div class="modal-content">\
                    <div class="modal-header">\
                        <h5 class="modal-title"><b>' + title + '</b></h5>\
                        <button type="button" class="close ' + agreement.ShowId + '-close" data-dismiss="modal" aria-label="Close">\
                        <span aria-hidden="true">&times;</span>\
                        </button>\
                    </div>\
                    <div class="modal-body">\
                        <p>Before participating in bounties or using tokens, you must agree to our latest <i>' + title + '</i>, which was last updated March 13, 2019.</p>\
                        <p>I' + (dn.user.IsLoggedIn ? (', ' + dn.user.Name + ',') : '') + ' agree to the following:</p>\
                        <p><b>Posting Bounties</b></p>\
                        <ul>\
                            <li>I will provide as much information as possible, following up with more information if requested.</li>\
                            <li>I will award my bounty within ' + dn.constants.BountyTimeoutDays + ' days of opening it.</li>\
                            <li>If I do not award my bounty, I understand it will be automatically closed.</li>\
                            <li>If my bounty is automatically closed, I understand it may be automatically awarded to those that participated in the discussion, or refunded to me, at the discretion of ' + dn.constants.CommunityName + '.</li>\
                            <li>If my bounty is refunded to me, I understand the tokens used to buy it are returned to my <a href="/wallet" target="' + dn.constants.LinkTargetNewWindow + '">token wallet</a>.</li>\
                        </ul>\
                        <p><b>Capturing Bounties</b></p>\
                        <ul>\
                            <li>I understand that replying to a bounty does not guarantee I will be awarded the bounty.</li>\
                            <li>I understand that not all bounties that are automatically closed will be automatically awarded.</li>\
                            <li>I will not copy & paste information from other sources to ' + dn.constants.CommunityName + ', nor violate any other copyright laws or terms of use of any third party services.</li>\
                        </ul>\
                        <p><b>Tokens</b></p>\
                        <ul>\
                            <li>I understand that bounties are purchased and paid out in ' + dn.constants.CommunityName + ' Tokens (' + dn.constants.TokenCurrencyCode + ').\
                            <li>I understand that tokens can be used to buy bounties, pay for ' + dn.constants.CommunityName + ' subscriptions, and in some countries, withdrawn as ' + dn.constants.TokenPurchaseCurrency + '.</li>\
                            <li>I understand that I may not be able to convert (withdraw) tokens into ' + dn.constants.TokenPurchaseCurrency + ' in my jurisdiction.</li>\
                            <li>I understand that the cost to buy tokens, and the exchange rate of withdrawn tokens may change at any time.</li>\
                        </ul>\
                        <p><b>I agree to abide by the above terms, and understand that ' + dn.constants.CommunityName + ' may terminate my ability to participate in bounties or token transactions at any time, for any reason. If I violate the ' + dn.constants.CommunityName + ' <a href="/terms" target="' + dn.constants.LinkTargetNewWindow + '">terms of use</a> or this agreement, I may be required to forfeit captured bounties.</b></p>\
                        <div class="alert alert-danger" style="display: none" id="' + agreement.ShowId + '-error" role="alert"></div>\
                        <p id="closing-modal"></p>\
                    </div>\
                    <div class="modal-footer ' + footerVisibility + '">\
                        <button type="button" class="btn btn-danger ' + agreement.ShowId + '-close" id="' + agreement.ShowId + '-cancel" data-dismiss="modal">Decline</button>\
                        <button type="button" class="btn btn-success" id="' + agreement.ShowId + '-button">I Agree</button>\
                    </div>\
                </div>\
            </div>\
        </div>'));

        // stop any spinners before showing our new one
        dn.Spin(false);

        // remember the modals that were already open before us, so we can show them when done. 
        var openModals = $('.modal.show');
        openModals.modal('hide');

        var id = '#' + agreement.ShowId;
        $(id).modal();

        // Decline or close button clicked
        $('.' + agreement.ShowId + '-close').click(function(e) {
            openModals.show(); // re-show modals that were open when we first appeared
            if (onClose)
            {
                onClose();
            }
        });

        // Agree button clicked
        $(id + '-button').click(function(e) {

            var $originalButtonClicked = $(e.target);

            $originalButtonClicked.attr('disabled', true);
            dn.Spin(true);

            $.postJSON("/api/v1/user/agreements", { AgreementType: agreementType })
            .done(function () {

                // update this immediately since their page may not be reloading, and we don't want to show it again
                dn.user.DateAgreedBounties = new Date();

                $(id).modal('hide');
                $originalButtonClicked.attr('disabled', false);
                dn.Spin(false);
                openModals.show(); // re-show modals that were open when we first appeared
                if (onAgree)
                {
                    onAgree();
                }
            })
            .fail(function (xhr, textStatus, errorThrown) {
                $originalButtonClicked.attr('disabled', false);
                dn.Spin(false);
                var body = dn.FormatApiError(xhr.responseJSON);
                dn.ShowModal({ title: "Agreement Error", body: body, preserveOpenModals: true });
            });
        });

        $(id).modal('show');
    };

}(window.dn.agreement = window.dn.agreement || {}, jQuery));
